module.exports = __webpack_public_path__ + "static/media/espectroGota.a79d5f1f.png";